import { defineComponent as x, useModel as v, computed as o, useAttrs as d, openBlock as f, createElementBlock as c, createElementVNode as a, normalizeClass as l, withDirectives as w, mergeProps as k, vModelCheckbox as y, toDisplayString as C, renderSlot as N, createCommentVNode as V, mergeModels as z } from "vue";
import { omit as B } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
const M = { class: "isolate" }, A = ["disabled"], S = { class: "flex min-w-0 flex-col" }, T = /* @__PURE__ */ x({
  name: "RevToggle",
  inheritAttrs: !1,
  __name: "Toggle",
  props: /* @__PURE__ */ z({
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    position: { default: "left" },
    toggleClassNames: { type: [String, Boolean, Array, Object], default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const t = s, r = v(s, "modelValue"), u = o(() => B(d(), ["class"])), b = o(() => [
      d().class,
      e`group flex items-center`,
      t.label && e`gap-12`,
      t.position === "sticked" && e`justify-between`,
      t.disabled ? e`cursor-not-allowed` : e`cursor-pointer`
    ]), m = o(() => [
      e`bg-static-default-low border-action-default-mid peer-focus-visible-outline-default-hi`,
      e`rounded-lg relative flex h-24 w-[46px] shrink-0 items-center`,
      e`border`,
      e`before:text-action-default-low before:shadow-long before:rounded-full`,
      e`after:bg-action-default-min-hover after:rounded-full`,
      e`peer-checked:bg-action-success-hi peer-checked:before:bg-action-default-low`,
      e`peer-disabled:bg-static-default-low-disabled peer-disabled:border-action-default-mid-disabled peer-disabled:before:text-action-default-low-disabled peer-disabled:peer-checked:bg-action-success-hi-disabled`,
      e`before:absolute before:left-3 before:size-16 before:border-transparent before:bg-current before:content-['']`,
      e`after:pointer-events-none after:absolute after:right-9 after:z-[-1] after:size-48 after:opacity-0 after:content-['']`,
      e`peer-checked:border-none peer-checked:before:size-20 peer-checked:before:translate-x-[21px] peer-checked:after:translate-x-[21px]`,
      e`peer-hover:after:opacity-100`,
      e`peer-disabled:before:bg-current peer-disabled:before:shadow-none peer-disabled:after:hidden`,
      e`motion-safe:transition-all motion-safe:duration-[400ms] motion-safe:ease-in-out`,
      e`before:motion-safe:transition-all before:motion-safe:duration-[400ms] before:motion-safe:ease-in-out`,
      e`after:motion-safe:transition-all after:motion-safe:duration-[400ms] after:motion-safe:ease-in-out`,
      t.position !== "left" && e`order-1`,
      t.toggleClassNames
    ]), p = o(() => [
      e`body-1 line-clamp-2 motion-safe:transition-colors motion-safe:duration-[400ms] motion-safe:ease-in-out`,
      t.disabled ? e`text-action-default-hi-disabled` : e`text-action-default-hi`
    ]), g = o(() => [
      e`body-2 motion-safe:transition-colors motion-safe:duration-[400ms] motion-safe:ease-in-out`,
      t.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]);
    return (i, n) => (f(), c("div", M, [
      a("label", {
        class: l(b.value)
      }, [
        w(a("input", k(u.value, {
          "onUpdate:modelValue": n[0] || (n[0] = (h) => r.value = h),
          class: "peer sr-only",
          disabled: s.disabled,
          type: "checkbox"
        }), null, 16, A), [
          [y, r.value]
        ]),
        a("span", {
          class: l(m.value)
        }, null, 2),
        a("span", S, [
          a("span", {
            class: l(p.value)
          }, C(s.label), 3),
          i.$slots.default ? (f(), c("span", {
            key: 0,
            class: l(g.value)
          }, [
            N(i.$slots, "default")
          ], 2)) : V("", !0)
        ])
      ], 2)
    ]));
  }
});
export {
  T as default
};
